import { useState, useEffect, useContext } from 'react';
import {ErrorContext} from '../Contexts/ErrorContext'
import AgreementService from '../Services/AgreementService';
import {extractErrorMessage} from '../Services/RequestService';
import {removeFromCollection, replaceInCollection} from './utils';

export const useAgreements = () => {
    const [agreements, setAgreements] = useState([]);
    const token = localStorage.getItem("token");
    const {setError, success} = useContext(ErrorContext);

    const loadAll = async () => {
        try {
            let resp = await AgreementService.allAgreements(token);
            setAgreements(resp.data);
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const addAgreement = async (agreement) => {
        try {
            let resp = await AgreementService.addAgreement(agreement, token);
            setAgreements([...agreements, {...agreement, id: resp.data.id}]);
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const updateAgreement = async (agreement) => {
        try {
            await AgreementService.updateAgreement(agreement, token);
            setAgreements(replaceInCollection(agreement, agreements));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    const deleteAgreement = async (agreement) => {
        try {
            await AgreementService.deleteAgreement(agreement.id, token);
            setAgreements(removeFromCollection(agreement, agreements));
            success();
        }catch(e){
            setError(extractErrorMessage(e.response));
            throw e;
        }
    }

    useEffect(() => {
        loadAll()
    }, []);

    return [agreements, addAgreement, updateAgreement, deleteAgreement];
}


// WEBPACK FOOTER //
// ./src/Hooks/useAgreements.js